import { render, staticRenderFns } from "./StockSummary.vue?vue&type=template&id=58071bce&scoped=true&"
import script from "./StockSummary.vue?vue&type=script&lang=js&"
export * from "./StockSummary.vue?vue&type=script&lang=js&"
import style0 from "./StockSummary.vue?vue&type=style&index=0&id=58071bce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58071bce",
  null
  
)

export default component.exports